module.exports = __webpack_public_path__ + "static/img/bg-id.9d379dc3.webp";